//弹出框
import {
  Message
} from 'element-ui';

export let toast = {
  showToast(text, type, time) {
    if (!text || text == '') return;
    let customClass = "";
    let offset = 56;
    if (type == "success") {
      customClass = "successMsg";
    } else if (type == "warning") {
      customClass = "warningMsg";
    } else if (type == "blueWarning") {
      Message({ //通过消息
        offset: offset,
        message: text,
        type: "warning",
        customClass: type,
        duration: time ? time : 3000
      });
      return;
    } else if (type == "common") {
      Message({ //通知消息
        offset: offset,
        message: text,
        customClass: "commonMsg",
        duration: time ? time : 3000
      });
      return;
    } else if (type == "error") {
      Message.error({ //错误消息
        offset: offset,
        message: text,
        customClass: "errorMsg",
        duration: time ? time : 3000
      });
      return;
    }
    Message({ //通过消息
      offset: offset,
      message: text,
      type: type,
      customClass: customClass,
      duration: time ? time : 3000
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/loadingDialog.js